import * as React from "react";
import Svg, { Path, Rect } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={60}
      height={60}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M44.94 58.673H15.937a2.33 2.33 0 01-2.33-2.33V29.151a2.33 2.33 0 012.33-2.33H44.94a2.33 2.33 0 012.33 2.33v27.19a2.33 2.33 0 01-2.33 2.331z"
        fill="#F9A7A7"
      />
      <Path
        d="M24.853 26.821V37.18c1.396 0 1.396-1.165 2.793-1.165 1.397 0 1.397 1.165 2.794 1.165 1.396 0 1.396-1.165 2.792-1.165s1.396 1.165 2.793 1.165V26.82H24.853z"
        fill="#F9CFCF"
      />
      <Path
        d="M44.94 59.157H15.937a2.816 2.816 0 01-2.813-2.813v-27.19a2.816 2.816 0 012.813-2.814H44.94a2.816 2.816 0 012.813 2.813v27.19a2.816 2.816 0 01-2.813 2.814zM15.937 27.305a1.85 1.85 0 00-1.848 1.848v27.19a1.85 1.85 0 001.848 1.848H44.94a1.85 1.85 0 001.848-1.847v-27.19a1.85 1.85 0 00-1.848-1.849H15.937z"
        fill="#3762CC"
      />
      <Path
        d="M43.817 53.398h-4.125a.778.778 0 010-1.556h4.125a.778.778 0 010 1.556zM43.817 55.463h-4.125a.778.778 0 010-1.556h4.125a.778.778 0 010 1.556zM24.375 55.668h-7.121a.971.971 0 01-.971-.971v-2.978c0-.536.435-.971.97-.971h7.122c.537 0 .971.435.971.971v2.978a.97.97 0 01-.97.97z"
        fill="#E0EBFC"
      />
      <Path
        d="M7.352 55.348H1.875a.392.392 0 01-.392-.392V38.038c0-.217.175-.392.392-.392h5.477c.804 0 1.456.651 1.456 1.456v14.79c0 .804-.652 1.456-1.456 1.456z"
        fill="#4671C6"
      />
      <Path
        d="M10.149 39.096H8.808v14.503h1.34a.775.775 0 00.776-.775V39.871a.775.775 0 00-.775-.775z"
        fill="#E0EBFC"
      />
      <Path
        d="M38.613 44.613a1.871 1.871 0 00-1.871-1.871h-2.278a1.87 1.87 0 00-.135-3.736H22.606l1.21-.996c.858-.707 1.074-1.971.424-2.873a2.087 2.087 0 00-3.022-.393L15.64 39.34l.005.006a1.94 1.94 0 00-.754 1.024.48.48 0 01-.462.326h-3.505v11.582h3.513c.206 0 .395.13.456.327a1.933 1.933 0 001.846 1.362H32.53v-.014a1.87 1.87 0 000-3.713v-.015h2.764a1.87 1.87 0 100-3.741h1.448a1.871 1.871 0 001.87-1.871z"
        fill="#F9CFCF"
      />
      <Path
        d="M7.352 55.83H1.875A.876.876 0 011 54.955V38.037c0-.483.392-.875.875-.875h5.477A1.94 1.94 0 019.29 39.1v14.791c0 1.069-.87 1.939-1.938 1.939zm-5.387-.966h5.387a.975.975 0 00.973-.973v-14.79a.974.974 0 00-.973-.974H1.965v16.737z"
        fill="#3762CC"
      />
      <Path
        d="M10.149 54.081H8.808a.483.483 0 01-.483-.483V39.11a.486.486 0 01.482-.498h1.342a1.26 1.26 0 011.258 1.258v12.954c0 .693-.564 1.257-1.258 1.257zm-.859-.965h.859a.293.293 0 00.293-.292V39.87a.293.293 0 00-.293-.293H9.29v13.539z"
        fill="#3762CC"
      />
      <Path
        d="M47.87 6.204l-5.507-4.647A4.556 4.556 0 0038.767.53L27.849 2.122a1.908 1.908 0 00-1.633 1.888V16.57l11.706 3.729 9.948-1.187h3.809V6.204H47.87z"
        fill="#F9CFCF"
      />
      <Path
        d="M37.922 20.78a.473.473 0 01-.146-.023L26.07 17.028a.482.482 0 01-.336-.46V4.01c0-1.178.88-2.195 2.045-2.366L38.697.052a5.047 5.047 0 013.977 1.136l5.373 4.533h3.632c.266 0 .483.217.483.483V19.11a.483.483 0 01-.483.483h-3.78l-9.92 1.184a.458.458 0 01-.057.003zm-11.223-4.564l11.27 3.59 9.844-1.175a.52.52 0 01.057-.003h3.326V6.687H47.87a.482.482 0 01-.311-.114l-5.507-4.648a4.078 4.078 0 00-3.215-.917L27.918 2.6a1.433 1.433 0 00-1.22 1.41v12.206z"
        fill="#3762CC"
      />
      <Path
        fill="#6BDDDD"
        stroke="#48BEBE"
        strokeWidth={0.2}
        d="M9.1 4.1h32.8v16.8H9.1z"
      />
      <Rect
        x={11.5}
        y={6.5}
        width={28}
        height={12}
        rx={0.5}
        fill="#E0EBFC"
        stroke="#3762CC"
      />
      <Path
        d="M30 12.75a4.25 4.25 0 11-8.5 0 4.25 4.25 0 018.5 0z"
        fill="#E0EBFC"
        stroke="#3762CC"
      />
      <Path
        d="M26.858 10.651h-.727c.132.223.215.495.25.816H27l-.142.651h-.468c-.037.49-.182.857-.434 1.104-.253.248-.604.371-1.053.371l1.518 2.357V16h-.7l-1.632-2.543-.003-.515h.767c.257-.002.465-.077.625-.222.16-.149.262-.35.305-.602H24l.142-.651h1.635c-.098-.522-.4-.794-.905-.816h-.866l.145-.651H27l-.142.651zM53.61 21.391h5.398a.386.386 0 00.387-.386V4.33a.386.386 0 00-.387-.387H53.61c-.793 0-1.435.643-1.435 1.435v14.578c0 .793.642 1.435 1.435 1.435z"
        fill="#4671C6"
      />
      <Path
        d="M41.924 12.904l-10.646.49a2.481 2.481 0 00-.726.034h-.002a2.481 2.481 0 00.221 4.9l9.349 1.195c1.199.154 2.411.167 3.613.041l2.745-.287.66-6.373h-5.214z"
        fill="#F9CFCF"
      />
      <Path
        d="M42.104 20.132c-.684 0-1.367-.044-2.045-.13l-9.35-1.195a2.937 2.937 0 01-1.981-1.08 2.943 2.943 0 01-.644-2.175 2.948 2.948 0 012.389-2.6c.267-.052.542-.066.816-.041l10.613-.489a.483.483 0 01.044.964l-10.646.49c-.023.001-.047 0-.07-.002a1.998 1.998 0 00-.585.027l-.015.003a1.987 1.987 0 00-1.586 1.748c-.056.531.098 1.052.434 1.467.335.415.813.673 1.343.73l9.36 1.195c1.16.148 2.338.162 3.502.04l2.745-.288a.482.482 0 11.1.96l-2.744.288c-.558.059-1.12.088-1.68.088z"
        fill="#3762CC"
      />
      <Path
        d="M52.175 5.378v-.006h-1.322a.764.764 0 00-.764.764v12.768c0 .422.342.764.764.764h1.322V5.378z"
        fill="#E0EBFC"
      />
      <Path
        d="M59.008 21.875H53.61a1.92 1.92 0 01-1.918-1.918V5.38a1.92 1.92 0 011.918-1.918h5.398c.48 0 .87.39.87.87v16.674c0 .48-.39.87-.87.87zM53.61 4.427a.953.953 0 00-.953.953v14.578c0 .525.428.952.953.952h5.302V4.427H53.61z"
        fill="#3762CC"
      />
      <Path
        d="M52.175 20.151h-1.322c-.688 0-1.247-.56-1.247-1.247V6.137c0-.687.56-1.246 1.247-1.246h1.322c.266 0 .483.216.483.482V19.67a.483.483 0 01-.483.482zM50.853 5.856a.282.282 0 00-.282.281v12.767c0 .156.127.282.282.282h.84V5.856h-.84zM32.53 54.45H16.74a2.403 2.403 0 01-2.308-1.703l-3.508.014a.483.483 0 01-.482-.483V40.697c0-.266.216-.483.482-.483h3.505c.15-.471.455-.9.862-1.206a.516.516 0 01.042-.039l5.578-4.596a2.585 2.585 0 011.963-.565 2.548 2.548 0 011.757 1.049c.788 1.093.565 2.642-.508 3.527l-.172.141H34.33a2.356 2.356 0 012.353 2.354c0 .513-.167.992-.452 1.381h.512a2.356 2.356 0 012.353 2.354 2.357 2.357 0 01-1.93 2.315c.303.397.483.891.483 1.427a2.356 2.356 0 01-2.354 2.354h-1.086a2.352 2.352 0 01-1.503 3.707.458.458 0 01-.175.034zm-21.123-2.654h3.03a.95.95 0 01.917.666 1.443 1.443 0 001.385 1.023h15.675a.428.428 0 01.06-.011 1.387 1.387 0 000-2.755.483.483 0 01-.427-.479c0-.266.216-.497.483-.497h2.764a1.39 1.39 0 001.388-1.388 1.39 1.39 0 00-1.388-1.389.483.483 0 010-.965h1.448a1.39 1.39 0 001.388-1.388 1.39 1.39 0 00-1.388-1.389h-2.278a.483.483 0 01-.035-.964 1.391 1.391 0 001.288-1.382 1.39 1.39 0 00-1.388-1.389H22.606a.482.482 0 01-.307-.855l1.21-.996c.682-.562.83-1.536.339-2.218a1.594 1.594 0 00-1.098-.656 1.59 1.59 0 00-1.226.353l-5.513 4.543a.456.456 0 01-.093.085c-.27.185-.47.458-.566.768a.967.967 0 01-.924.666h-3.021v10.617z"
        fill="#3762CC"
      />
      <Path
        d="M32.308 54.45h-8.903a.483.483 0 010-.965h8.903a1.39 1.39 0 001.388-1.388 1.39 1.39 0 00-1.388-1.389h-6.962a.483.483 0 010-.965h6.962a2.356 2.356 0 012.353 2.354 2.356 2.356 0 01-2.353 2.353z"
        fill="#3762CC"
      />
      <Path
        d="M35.294 50.708h-9.948a.483.483 0 010-.965h9.948a1.39 1.39 0 001.388-1.388 1.39 1.39 0 00-1.388-1.389h-9.948a.483.483 0 010-.965h9.948a2.356 2.356 0 012.354 2.354 2.356 2.356 0 01-2.354 2.353z"
        fill="#3762CC"
      />
      <Path
        d="M36.742 46.967H25.346a.483.483 0 010-.965h11.396a1.39 1.39 0 001.388-1.389 1.39 1.39 0 00-1.388-1.388l-11.395.007a.483.483 0 01-.001-.965l11.396-.007a2.356 2.356 0 012.353 2.353 2.356 2.356 0 01-2.353 2.354z"
        fill="#3762CC"
      />
    </Svg>
  );
}

export default SvgComponent;
